// SmallMultipleCard.jsx

import React, { useState } from 'react';
import TrendChartNivo from './TrendChartNivo';
import SmallMultiplesGrid from './SmallMultiplesGrid';
function SmallMultipleCard({ node, metricMode, totalNonfarmValues }) {
  const [expanded, setExpanded] = useState(false);

  const transformed = transformValues(node.value, metricMode, totalNonfarmValues);

  // Does this node have children?
  const hasChildren = Array.isArray(node.children) && node.children.length > 0;

  return (
    <div
      style={{
        border: '1px solid #ddd',
        borderRadius: '4px',
        background: '#fff',
        padding: '0.5rem',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h4 style={{ margin: 0 }}>{node.industry}</h4>
        {hasChildren && (
          <button
            onClick={() => setExpanded(!expanded)}
            style={{
              background: '#eee',
              border: '1px solid #ccc',
              borderRadius: 4,
              cursor: 'pointer',
              width: 24,
              height: 24,
            }}
          >
            {expanded ? '-' : '+'}
          </button>
        )}
      </div>

      {/* Mini chart for this node */}
      {transformed.length > 0 && (
        <TrendChartNivo 
          data={transformed}
          metricMode={metricMode}
          // Maybe smaller dimensions for the small-multiple vibe
          chartWidth={200}
          chartHeight={120}
        />
      )}

      {/* If expanded, show children as another small multiples grid,
          or you can call NodeChart, or do anything you like. */}
      {expanded && hasChildren && (
        <div style={{ marginTop: '1rem' }}>
          <SmallMultiplesGrid
            childrenNodes={node.children}
            metricMode={metricMode}
            totalNonfarmValues={totalNonfarmValues}
          />
        </div>
      )}
    </div>
  );
}

export default SmallMultipleCard;


// Re-use your same logic or keep it simple
function transformValues(values, metricMode, totalNonfarmValues) {
  if (!Array.isArray(values) || values.length === 0) {
    return [];
  }

  switch (metricMode) {
    case 'pctOfTotal':
      if (
        Array.isArray(totalNonfarmValues) &&
        totalNonfarmValues.length === values.length
      ) {
        return values.map((val, i) => {
          const total = totalNonfarmValues[i] || 1;
          return (val / total) * 100;
        });
      }
      return values;

    case 'yoyGrowth':
      return values.map((val, i, arr) => {
        if (i === 0) return 0;
        const prev = arr[i - 1];
        if (!prev) return 0;
        return ((val - prev) / prev) * 100;
      });
      case 'since2000': {
        return values.map((val, i, arr) => {
          const base = arr[0];
          if (i === 0) return 0;
          return base ? ((val - base) / base) * 100 : 0;
        });
      }
    default:
      return values;
  }
}